import { rootApi } from "../../api/rootApi";

export const vendorThemeApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        verifyUserSession: builder.mutation({
            query: ({ token, tenant_id }) => {
                return {
                    method: "GET",
                    url: "/unprotected/user-session/verify",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + token,
                        ...(tenant_id
                            ? {
                                  slug: tenant_id,
                              }
                            : {}),
                    },
                };
            },
        }),
    }),
});
export const { useVerifyUserSessionMutation } = vendorThemeApi;
